// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BzUWz","footer":"styles_footer__3Wb1g","passCodeTooltip":"styles_passCodeTooltip__3iRT9"};